export default __webpack_public_path__ + "static/media/ocean-bg-9.a1f7459c.jpeg";